import { AudioHelper } from "../../../../../../library-js/audio/AudioHelper";
import { WaveForm } from "../../../../../../library-js/audio/visualization/wave-form/WaveForm";
import { WaveformChannelType, WaveformGenerationOptions } from "../../../../../../library-js/audio/visualization/wave-form/WaveFormGenerationOptions";
import { WaveFormRenderer } from "../../../../../../library-js/audio/visualization/wave-form/WaveFormRenderer";
import { AttributeValue } from "../../../../../../library-js/dom-tools/AttributeValue";
import { ElementType } from "../../../../../../library-js/dom-tools/ElementType";
import { OnChange, OnLoad } from "../../../../../../library-js/dom-tools/EventListeners";
import { KeyboardSensorID } from "../../../../../../library-js/sensors/KeyboardSensorID";
import { AppCommand } from "../../../../../../library-js/web-app/commands/AppCommand";
import { AppCommandBinding } from "../../../../../../library-js/web-app/commands/AppCommandBinding";
import { AppCommandBindingEntry } from "../../../../../../library-js/web-app/commands/AppCommandBindingEntry";
import { AppCommandContext } from "../../../../../../library-js/web-app/commands/AppCommandContext";
import { AudioEditor } from "../../AudioEditor";
import { AudioEditorSelection } from "../../selection/AudioEditorSelection";

export class Play extends AppCommand
{
  initialize()
  {
    this._name = 
    {
      en: "Play",
      de: "Abspielen" 
    }

    this._info = 
    {
      en: "Plays the sound",
      de: "Spielt den Sound ab"
    }

    this._shortCutEntries = 
    [
      AppCommandBindingEntry.forDesktop( AppCommandBinding.primaryWith( KeyboardSensorID.Space ) )
    ]
  }

  async _execute( commandContext:AppCommandContext<any,any> ):Promise<void>
  {
    let app = commandContext.webApp as AudioEditor;
    let audioContext = app.audioContext;
    let selection = app.selection as AudioEditorSelection;

    let promise = new Promise<void>(
      ( resolve, reject )=>
      {
        const source    = audioContext.createBufferSource();

        source.loop      = selection.looping.value;
        source.loopStart = selection.playStart.value * app.project.audioBuffer.duration;
        source.loopEnd   = selection.playEnd.value * app.project.audioBuffer.duration;

        source.buffer = app.project.audioBuffer;

        source.connect( audioContext.destination );

        source.start();
      }
    );

    return Promise.resolve( promise );
  }
}